<template>
    <div>
        <b-form-group :label="$t('scheduled_tasks.specific_time.execution_times')">
            <b-input-group>
              <!--  <Datepicker class="mr-3" v-model="datepick" />
                <Timepicker class="mr-3" v-model="timepick" />
                <b-input-group-append>
                    <button type="button" @click="onAddTime" >{{ $t('button.add') }}</button>
                </b-input-group-append> -->
            </b-input-group>
            <b-input-group>
                <b-form-datepicker v-model="datepick" :locale="locale" size="sm" start-weekday="1" v-bind="dateTranslations || {}"></b-form-datepicker>
                <b-form-timepicker v-model="timepick" :locale="locale" size="sm" :hour12=false v-bind="timeTranslations || {}"></b-form-timepicker>
                <b-input-group-append>
                    <button type="button" @click="onAddTime">{{ $t('button.add') }}</button>
                </b-input-group-append>
            </b-input-group>
            <b-input-group v-for="timestring in timestrings" :key="timestring">
                <b-form-input :readonly="true" :value="timestring"></b-form-input>
                <b-input-group-append>
                    <button type="button" :value="timestring" @click="onRemoveTime">{{ $t('button.remove') }}</button>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
    </div>
</template>

<script>
//import Datepicker from '@/components/Generic/Datepicker'
//import Timepicker from '@/components/Generic/Timepicker'
import moment from 'moment'

export default {
    name: 'SpecificTimeScheduleSettings',
    components: {
//        Datepicker,
//        Timepicker
    },
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data: function() {
        return  {
            datepick: null,
            timepick: null
        };
    },
    computed: {
        timestrings: {
            get: function() {
                if (this.value.time)
                    // Palautetaan sortattu kopio, koska value propin muokkaileminen suoraan ei ole hyvästä.
                    return [...this.value.time].sort();
                else
                    return this.value.time;
            },
            set: function(newValue) {
                // newValue on tyypiltään array.
                this.$emit('input', { ...this.value, ['time']: newValue });
            }
        },
        locale: function() {
            return this.$t('datepicker.locale');
        },
        dateTranslations: function() {
            return this.$t('datepicker');
        },
        timeTranslations: function() {
            return this.$t('timepicker');
        }
    },
    methods: {
        onAddTime() {
            if (this.datepick != null && this.timepick != null) {
                var m = moment(this.datepick, 'YYYY-MM-DD');
                if (m.isValid()) {
                    var time = this.datepick +' '+ this.timepick;
                    
                    if (!this.timestrings) {
                        this.timestrings = [time];
                    } else
                    if (!this.timestrings.includes(time)) {
                        this.timestrings = [...this.timestrings, time].sort();
                    }
                }
            }
        },
        onRemoveTime(event) {
            var time = event.target.value;
            if (this.timestrings && this.timestrings.includes(time)) {
                var newTimes = [...this.timestrings];
                newTimes.splice(newTimes.indexOf(time), 1);
                this.timestrings = newTimes;
            }
        }
    }
}
</script>